import { MessagesSquare } from "lucide-react"
import type { RuntimeRecord } from "../../nest/generated"

export interface ProcessTaskTarget {
    nodeId: string
    workspaceId: string
    taskId: string
}

export interface ProcessTaskNavigation {
    open(task: ProcessTaskTarget): void
    busy: boolean
}

export function ProcessTaskLink({
    process,
    nodeId,
    current = false,
    navigation,
}: {
    process: RuntimeRecord
    nodeId: string
    current?: boolean
    navigation: ProcessTaskNavigation
}) {
    const taskId = process.labels?.["wildlark.taskId"]
    if (!taskId) return null
    const title = process.labels?.["wildlark.taskTitle"] || "Task"
    const workspaceId = process.labels?.["wildlark.workspaceId"]
    if (!workspaceId)
        return (
            <span className="truncate text-muted" title="Task location unavailable">
                {title}
            </span>
        )
    const target = { taskId, workspaceId, nodeId: process.labels?.["wildlark.originNodeId"] || nodeId }
    return (
        <button
            type="button"
            className="btn flex w-full min-w-0 items-center gap-1 overflow-hidden text-primary hover:underline focus-visible:outline focus-visible:outline-primary disabled:opacity-40 max-sm:min-h-7"
            aria-label={`Open task: ${title}`}
            title={`Open task: ${title}`}
            disabled={navigation.busy}
            onClick={() => navigation.open(target)}
        >
            <MessagesSquare size={11} className="shrink-0" />
            <span className="min-w-0 flex-1 truncate">{current ? "This task" : title}</span>
        </button>
    )
}
